module.exports = "https://www.gc-qa.gnp.com.mx/cd2d6460aee910b80673557fc5e644d0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/dbk-nwb-validacion.svg
// module id = 8094
// module chunks = 0